import { createContext, ReactNode, useState, useMemo, useContext } from 'react';

import type { InteractiveLessonSectionFragment } from './lesson-builder.graphql.generated';
import {
  DraftAssessmentActivities,
  DraftLessonActivities,
} from './activity-builder-draft.constants';

type ActivityBuilderApollo = {
  interactiveLessonClone:
    | DraftLessonActivities
    | DraftAssessmentActivities
    | undefined
    | null;
  interactiveSectionClone: InteractiveLessonSectionFragment | undefined | null;
  setInteractiveLessonClone: (
    data: DraftLessonActivities | DraftAssessmentActivities | undefined | null
  ) => void;
  setInteractiveSectionClone: (
    data: InteractiveLessonSectionFragment | undefined | null
  ) => void;
};

export const ActivityBuilderApolloContext =
  createContext<ActivityBuilderApollo>({
    interactiveLessonClone: undefined,
    interactiveSectionClone: undefined,
    setInteractiveLessonClone: () => {},
    setInteractiveSectionClone: () => {},
  });

export const ActivityBuilderApolloContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [interactiveLessonClone, setInteractiveLessonClone] = useState<
    DraftLessonActivities | DraftAssessmentActivities | undefined | null
  >();
  const [interactiveSectionClone, setInteractiveSectionClone] = useState<
    InteractiveLessonSectionFragment | undefined | null
  >();

  const value = useMemo(
    () => ({
      interactiveLessonClone,
      interactiveSectionClone,
      setInteractiveLessonClone,
      setInteractiveSectionClone,
    }),
    [
      interactiveLessonClone,
      interactiveSectionClone,
      setInteractiveLessonClone,
      setInteractiveSectionClone,
    ]
  );

  return (
    <ActivityBuilderApolloContext.Provider value={value}>
      {children}
    </ActivityBuilderApolloContext.Provider>
  );
};

export const useActivityBuilderApolloContext = () =>
  useContext(ActivityBuilderApolloContext);
